<ion-content
  [ngClass]="
    platform !== platformReference.desktop
      ? platform === platformReference?.tablet
        ? 'ion-content-tablet'
        : 'ion-content-mobile'
      : 'ion-content-desktop'
  "
>
  <div class="calendar-container">
    <div class="calendar-body">
      <div class="calendar-date">
        <p *ngIf="multiSelectMode !== modeReference.IonicDefault">
          <ion-icon name="calendar-outline"> </ion-icon>
          <span class="calendar-date-show">
            {{ 'i18n.common.dateSelect' | translate }}
          </span>
          <span class="calendar-date-value">
            {{ dateOne ? (dateOne | date: 'MM/dd/yyyy') : 'MM/DD/YYYY' }}
          </span>
          <span class="dash">-</span>
          <span class="calendar-date-value">
            {{ dateTwo ? (dateTwo | date: 'MM/dd/yyyy') : 'MM/DD/YYYY' }}
          </span>
        </p>
        <p *ngIf="multiSelectMode === modeReference.IonicDefault">
          <ion-icon name="calendar-outline"> </ion-icon>
          <span class="calendar-date-show">
            {{ 'i18n.common.dateSelect' | translate }}
          </span>
          <span class="calendar-date-value">
            {{
              selections.length > 0
                ? (selections[0] | date: 'MM/dd/yyyy')
                : 'MM/DD/YYYY'
            }}
          </span>
          -
          <span class="calendar-date-value">
            {{
              selections.length > 1
                ? (selections[selections.length - 1] | date: 'MM/dd/yyyy')
                : 'MM/DD/YYYY'
            }}
          </span>
        </p>
        <!-- multi select version -->
      </div>
      <ion-datetime
        id="date"
        [presentation]="'date'"
        [multiple]="true"
        [ngModel]="selections"
        (ionChange)="handleValue($event)"
        [min]="minDate"
        [max]="maxDate"
        mode="ios"
        [dayValues]="dayValues"
      >
      </ion-datetime>
    </div>
  </div>

  <div class="reset">
    <a (click)="reset()"> {{ 'i18n.common.reset' | translate }}</a>
  </div>
</ion-content>
